import { z } from "zod";

import { oauthRefreshSchema } from "../../../../../lib/types/schema/oauthRefreshSchema.schema";
import { meSchema } from "../../../../../lib/types/schema/user/meSchema";

export const authSchema = z.object({
  oauth: oauthRefreshSchema,
  is_new: z.boolean(),
  user: meSchema,
});

export const booleanSuccessSchema = z.boolean();

export type Auth = z.TypeOf<typeof authSchema>;
